import api from "../../services/api";
import { gmapApi } from "vue2-google-maps";
import moment from "moment";
import formatcoords from "formatcoords";
import helpers from "../../shared/fleetbox-helpers";
import { Marker, GeoPosition } from "../../domain/poi";
import { bus } from "../../main";
import mapPoiCategoriesFilter from "../../components/map/poicategories.vue";
import { mapGetters } from "vuex";

export default {
	components: {
		mapPoiCategoriesFilter
	},
	props: {
		data: Array,
		vehicleIdFilterField: String,
		mapCenterLocation: {
			type: Object,
			default: {
				lat: 0,
				lng: 0
			}
		},
		zoom: {
			type: Number,
			default: 18
		}
	},
	data: function() {
		return {
			firstTimeIn: true,
			center: {},
			markers: [],
			infoContent: "",
			infoWindowPos: null,
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				content: "",
				pixelOffset: {
					width: 0,
					height: -35
				}
			},

			//POI
			poiAreas: [],
			poiPaths: [],
			poiMarkers: [],

			viewSatellite: false,
			mapStylesOptions: [ 
				{
					featureType: "poi",
					stylers: [ 
						{ 
							visibility: "off" 
						} 
					] 
				} 
			],
			historyBounds: null,
			notHasTripsDataPermission: true,
			showPhoneNumber: false
		};
	},
	watch: {},
	created() {
		if (this.settings) {
			if (this.settings.viewSatellite) {
				this.viewSatellite = this.settings.viewSatellite;
			}

			if (this.settings.show_phone_in_map) {
				this.showPhoneNumber = true;
			}
		}
		var self = this;

		if (this.scopes && this.scopes.length > 0) {
			this.notHasTripsDataPermission =
				this.scopes.some(item => {
					return item == "TRIPS_DATA";
				}) == false;
		}

		self.center = {
			lat: self.mapCenterLocation.lat,
			lng: self.mapCenterLocation.lng
		};

		self.$gmapApiPromiseLazy().then(() => {
			self.$watch(
				"data",
				function(newValue, oldValue) {
					self.displayMarkers();
				},
				{ deep: true }
			);
		});

		bus.$on("poi-category-filter-change", self.onPoiCategoryFilterChange.bind(self));
		bus.$on("on-filter-changed", self.displayMarkers.bind(self));
		bus.$on("updated-data", self.onUpdatedData.bind(self));
	},
	mounted() {
		/* poi categories */
		var self = this;

		if (this.settings && this.settings.viewPoi) {
			this.$nextTick(() => {
				self.$refs.map.$gmapApiPromiseLazy().then(res => {
					self.$refs.poiCatgeoriesFilter.loadControls(self.$refs.map);
				});
				//}, 1000);
			});
		}
		/* poi categories */
	},
	beforeDestroy() {
		var self = this;
		bus.$off("poi-category-filter-change", self.onPoiCategoryFilterChange.bind(self));
		bus.$off("on-filter-changed");
		bus.$off("updated-data");
	},
	/* metodi */
	methods: {
		markerOut() {
			helpers.deleteTooltip();
		},
		markerOver($event, m) {
			helpers.injectTooltip($event.tb, m.description);
		},
		onUpdatedData() {
			this.hideAllInfoWindow();
		},
		displayPois: function(data) {
			var self = this;

			//items to remove - marker
			var itemsToRemove = [];
			for (let i = 0; i < this.poiMarkers.length; i++) {
				var m = this.poiMarkers[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiMarkers.findIndex(function(o) {
					return o.id == r;
				});

				self.poiMarkers.splice(index, 1);
			});

			//items to remove - polygon
			itemsToRemove = [];
			for (let i = 0; i < this.poiPaths.length; i++) {
				var m = this.poiPaths[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiPaths.findIndex(function(o) {
					return o.id == r;
				});

				self.poiPaths.splice(index, 1);
			});

			//items to remove - area
			itemsToRemove = [];
			for (let i = 0; i < this.poiAreas.length; i++) {
				var m = this.poiAreas[i];
				let dataItem = _.find(data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.poiAreas.findIndex(function(o) {
					return o.id == r;
				});

				self.poiAreas.splice(index, 1);
			});

			data.forEach(function(item) {
				if (item.location.rendering_type == "marker" || (item.location.rendering_type == "unknown" && item.location.points.length == 1)) {
					let m = _.find(self.poiMarkers, function(o) {
						return o.id == item.id;
					});

					if (m == null) {
						m = new google.maps.Marker();
						m.id = item.id;
						m.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: -40
							}
						};

						self.poiMarkers.push(m);
					}

					m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					m.description = item.name;
					m.info = `<b>${item.name}</b><br />
								LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
								INDIRIZZO: ${item.location.address}<br />`;

					if (item.poi_category_icon_image) {
						var icon = {
							url: item.poi_category_icon_image,
							scaledSize: new google.maps.Size(30, 36), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
						m.icon = icon;
					}
					m.infoWindowOptions.content = m.info;
				} else if (item.location.rendering_type == "polygon" || (item.location.rendering_type == "unknown" && item.location.points.length > 1)) {
					//marker related to polygon
					if (!self.isInEditMode) {
						let m = _.find(self.poiMarkers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.poiMarkers.push(m);
						}

						m.draggable = false;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.description = item.name;
						m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}

					//polygon
					let p = _.find(self.poiPaths, function(o) {
						return o.id == item.id;
					});

					if (p == null) {
						p = {
							id: item.id,
							path: item.location.points.map(function(pt) {
								return new GeoPosition(pt.lat, pt.lon);
							}),
							infoWindowOptions: {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: 0
								}
							}
						};

						self.poiPaths.push(p);
					}

					p.fillColor = item.poi_category_fill_color;
					p.description = item.name;
					p.info = `<b>${item.name}</b><br />
									LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									INDIRIZZO: ${item.location.address}<br />`;
					p.infoWindowOptions.content = p.info;
				} else if (item.location.rendering_type == "circle") {
					//marker related to circle
					if (!self.isInEditMode) {
						let m = _.find(self.poiMarkers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.poiMarkers.push(m);
						}

						m.draggable = item.draggable;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.description = item.name;
						m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}
					//area
					let a = _.find(self.poiAreas, function(o) {
						return o.id == item.id;
					});

					if (a == null) {
						a = new google.maps.Circle();
						a.id = item.id;
						a.radius = item.radius;
						a.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: 0
							}
						};

						self.poiAreas.push(a);
					}
					a.center = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					a.fillColor = item.poi_category_fill_color;
					a.description = item.name;
					a.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
					a.infoWindowOptions.content = a.info;
				}
			});
		},
		poiMarkerClick: function(marker) {
			helpers.deleteTooltip();
			this.hideAllInfoWindow();
			this.toggleInfoWindow(marker);
		},

		onPoiCategoryFilterChange(items) {
			this.displayPois(items);
		},

		displayMarkers: function() {
			var self = this;

			//items to remove
			var itemsToRemove = [];
			for (let i = 0; i < this.markers.length; i++) {
				var m = this.markers[i];
				let dataItem = _.find(this.data, d => {
					return d.id == m.id;
				});

				if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			}

			itemsToRemove.forEach(r => {
				let index = self.markers.findIndex(function(o) {
					return o.id == r;
				});

				self.markers.splice(index, 1);
			});

			self.data.forEach(function(item, index) {
				if (item.current_position) {
					if (item.visible) {
						let m = _.find(self.markers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.markers.push(m);
						}

						m.position = new GeoPosition(item.current_position.lat, item.current_position.lon);
						m.description = `${item.vehicle_name} - ${item[self.vehicleIdFilterField]}`;
						var lastStatusDate = moment(item.status_date);
						var now = moment();
						var timeToOff = "";

						if (item.status == "off") {
							var diff = now.diff(lastStatusDate, "days");
							timeToOff = `${diff} GIORNO/I`;
							if (diff == 0) {
								diff = now.diff(lastStatusDate, "hours");
								timeToOff = `${diff} ORA/E`;
							}
							if (diff == 0) {
								diff = now.diff(lastStatusDate, "minutes");
								timeToOff = `${diff} MINUTO/I`;
							}
							if (diff == 0) {
								diff = now.diff(lastStatusDate, "seconds");
								timeToOff = `${diff} SECONDO/I`;
							}
						}

						var startDateFilter = moment(item.status_date);
						let linkToTrip = '';
						let showTrip = item.type == "trip";
						if (showTrip) {
							linkToTrip = `<br/><a href="/trips?vehicleId=${item[self.vehicleIdFilterField]}&pathId=${item.id}&code=${
								item.vehicle_id
							}&startDay=${startDateFilter.utc().format()}"><u style="cursor: pointer; color: #000">mostra viaggio</u></a>`;
						}
						
						var tooltipInfo = `<b class="header">${item.vehicle_name ? item.vehicle_name : "---"} - ${item[self.vehicleIdFilterField]}</b><br/>
								<b class="driver">Conducente: ${item.driver_name}</b><br/>
								${self.showPhoneNumber && item.mobile_phone_number ? '<span class="blackColor">TEL.: </span><a target="_blank" href="https://api.whatsapp.com/send?phone=' + item.mobile_phone_number + '">' + item.mobile_phone_number + '</a><br/>': '<span class="blackColor">TEL.: </span>ND<br/>'}
								<span class="odometer-liter"><span class="blackColor">KM</span> ${item.last_odometer_km_value} - <span class="blackColor">LT</span> ${item.last_odometer_lt_value} (RILEVAZIONE CAN BUS) </span><br/>
								<div class="row mx-0 w-360">
									<div class="col-xs-6 fs-10 w-170 mr-30">
										${item.formattedCoordinates} - ${item.address}<br/>
									</div>
									<div class="col-xs-6 fs-10 lh-13 w-180 black ttTable t-center">
										<div class="inline-block t-left">
											${item.statusFriendly} - ${item.last_speed} Km/h<br/>
											${self.$options.filters.datetimeToString(item.last_event_date)}<br/>
											${item.status == "off" ? '<i class="icon-stop-clock"></i>&nbsp;' + timeToOff + "<br/>" : ""}
											${self.notHasTripsDataPermission == false && showTrip ? linkToTrip : ""}	
										</div>
									</div>
								</div>`;
						m.info = tooltipInfo;

						//m.info = "<b>" + item.vehicle_name + "</b><br/>Posizionee<br/>lat: " + item.current_position.lat + " lon: " + item.current_position.lon + '<br>' + item.last_event_date;
						m.icon = {
							url: item.icon, // url
							scaledSize: new google.maps.Size(30, 36), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
						m.infoWindowOptions.content = m.info;
					}
				}
			});

			setTimeout(function() {
				self.fitAndZoom();
			}, 1);
		},
		fitAndZoom: function(bnds) {
			var self = this;

			var bounds = new google.maps.LatLngBounds();

			if (bnds) {
				bounds = bnds;
			} else {
				self.markers.forEach(function(item, index) {
					bounds.extend(item.position);
				});
			}

			if (self.markers.length > 0 && bounds.equals(self.historyBounds) == false) {
				if (self.$refs.map) {
					self.$refs.map.$mapPromise.then(map => {
						map.fitBounds(bounds);
						if (map.getZoom() >= 22) {
							map.setZoom(14);
						}
					});

					self.historyBounds = bounds;
				}
			}
		},
		setCustomZoom(value) {
			var self = this;
			if (self.$refs.map) {
				self.$refs.map.$mapPromise.then(map => {
					map.setZoom(value);
				});
			}
		},
		markerClick: function(marker, idx) {
			var self = this;
			var showTooltip = function() {
				self.hideAllInfoWindow();
				self.toggleInfoWindow(marker);
			};
			this.$emit("get-adress", marker.id, showTooltip);
		},
		clusterClick(e) {
			var bounds = e.getBounds();
			// this.fitAndZoom(bounds);
		},
		hideAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			//POI
			self.poiMarkers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.poiPaths.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.poiAreas.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});
		},
		showAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = true;
			});
		},
		// centerMap: function(position) {
		// 	var self = this;

		// 	self.$refs.map.$mapPromise.then(map => {
		// 		map.setCenter(position);
		// 	});
		// },
		toggleInfoWindow: function(marker, idx) {
			marker.infoWindowOptions.infoWindowOpened = !marker.infoWindowOptions.infoWindowOpened;

			// this.infoWindowPos = marker.position;
			// this.infoContent = marker.info;
			// this.infoOptions.content = marker.info;
			// //check if its the same marker that was selected if yes toggle
			// if (this.currentMidx == idx) {
			// 	this.infoWinOpen = !this.infoWinOpen;
			// }
			// //if different marker set infowindow to open and reset current marker index
			// else {
			// 	this.infoWinOpen = true;
			// 	this.currentMidx = idx;
			// }
		}
	},
	computed: {
		...mapGetters(["settings", "scopes"])
	}
};
